import { DestroyRef, Injectable, inject } from '@angular/core';
import { PlatformService } from '@lentau/ui-kit/core/services/platform/platform.service';
import { DefaultStoreFacade } from '@lentau/address/default-store/store/default-store.facade';
import { AuthFacade } from '@lentau/auth/store';
import { WINDOW } from '@lentau/ui-kit/core/tokens/window';
import { isLenta } from '@lentau/ui-kit/core/helpers/isBrand.helper';
import { filter, switchMap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CityStoreFacade } from '@lentau/city/store/city.facade';

@Injectable({
  providedIn: 'root',
})
export class AddressesUtmListenerService {
  private platformService: PlatformService = inject(PlatformService);
  private window: Window = inject(WINDOW);
  private defaultStoreFacade: DefaultStoreFacade = inject(DefaultStoreFacade);
  private authFacade: AuthFacade = inject(AuthFacade);
  private cityFacade: CityStoreFacade = inject(CityStoreFacade);
  private destroyRef: DestroyRef = inject(DestroyRef);

  public init(): void {
    if (isLenta() && !this.platformService.isServer) {
      const queryParams: string = this.window.location.search;

      if (queryParams) {
        const params: URLSearchParams = new URLSearchParams(window.location.search);
        const utmCampaign: string = params.get('utm_campaign');
        const utmUserMode: string = params.get('utm_user_mode');

        if (utmCampaign || utmUserMode) {
          this.cityFacade.city$
            .pipe(
              filter(Boolean),
              switchMap(() => this.authFacade.userAuthorizeType$.pipe(filter(Boolean))),
              takeUntilDestroyed(this.destroyRef)
            )
            .subscribe(() => {
              this.defaultStoreFacade.defaultStore(this.cityFacade.citySlug(), utmCampaign, utmUserMode);
            });

          return;
        }
      }
    }

    // Должен вызываться только если не запрашивается магазин по умолчанию
    this.defaultStoreFacade.checkNotNeeded();
  }
}
